<template>
    <div    class="">
        <tailwind-table     :headers="headers"
                            :data="characteristic.history"
                            :exportable="false"
                            :export-csv-header="csvHeaders"
        >
            <template   #col-4="props">
                <div    class="w-2/3 flex justify-center">
                    <small-colored-check    v-model="props.row.written"></small-colored-check>
                </div>
            </template>
        </tailwind-table>
    </div>
</template>

<script>
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import {iconNamesMixin} from '@/mixins/IconNamesMixin';
import TailwindTable from "@/components/elements/TailwindTable";
import SmallColoredCheck from "@/components/elements/SmallColoredCheck";

export default {
    name: "CharacteristicHistory",
    mixins: [SonicuCoreMixin, iconNamesMixin],
    components: {SmallColoredCheck, TailwindTable},
    props: {
        characteristic: Object,
    },
    data() {
        return {
            headers: [
                {
                    name: 'Value',
                    sortBy: '',
                    key: 'prettyValue',
                },
                {
                    name: 'Updated By',
                    sortBy: '',
                    key: 'by'
                },
                {
                    name: 'Updated On',
                    sortBy: '',
                    key: 'on'
                },
                {
                    name: 'Written',
                    sortBy: '',
                    key: ''
                },
            ],
            csvHeaders: {
                'Characteristic Value': 'value',
                'Updated By': 'by',
                'Updated On': 'on',
                'Written': '',
            }
        }
    },
    created() {
        
    },
    mounted() {
        
    },
    methods: {
        
    },
    computed: {
        
    },
    watch: {
        
    },
}
</script>

<style scoped>

</style>